import { useQuery } from '@tanstack/react-query';
import { getModerationCaseDetails } from '../services/moderation';
import { moderationQueryKeys } from './query-keys';

export const useModerationCaseDetailsQuery = (caseId, options = {}) =>
  useQuery({
    queryKey: moderationQueryKeys.caseDetails(caseId),
    enabled: Boolean(caseId),
    queryFn: async () => {
      const result = await getModerationCaseDetails(caseId);
      if (!result.success) {
        throw new Error(result.message || 'Failed to fetch moderation case details');
      }
      return result.data;
    },
    ...options,
  });
